import { TimelineFilterType } from '@bariendo/lib/constants';

/**
 * Billing cards (payment order and events, refunds, employer benefit events) belong under
 * All and Billing only (BAR-2646). Every other filter neither fetches nor draws them.
 */
export function filterShowsBilling(activeFilter: string): boolean {
  return activeFilter === TimelineFilterType.ALL || activeFilter === TimelineFilterType.BILLING;
}

/**
 * Whether the timeline asks for billing cards at all: the filter shows them and the viewer
 * holds the one billing permission, `canViewPayments`. The same permission drops the Billing
 * chip (`getEnabledFilters`) and the panel's billing group, so no surface reaches the money
 * without it.
 */
export function showsBillingCards(activeFilter: string, canViewBilling: boolean): boolean {
  return canViewBilling && filterShowsBilling(activeFilter);
}

/**
 * The Billing filter for a role that holds the permission, All for one that does not: the
 * chip is dropped for them, so a shared `?type=billing` link would otherwise open on an
 * empty timeline with no active filter to clear.
 */
export function billingFilterOrAll<T extends string>(
  activeFilter: T,
  canViewBilling: boolean
): T | typeof TimelineFilterType.ALL {
  return activeFilter === TimelineFilterType.BILLING && !canViewBilling ? TimelineFilterType.ALL : activeFilter;
}
